namespace $.$$ {
    export class $bog_theme_picker_row extends $.$bog_theme_picker_row {
        focused_str() {
            return this.focused() ? 'true' : ''
        }
    }
}
